import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({
  baseURL: API,
  // Send/receive the httpOnly session cookie set by the backend so the JWT
  // never touches JS-readable storage.
  withCredentials: true,
});

client.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      const path = window.location.pathname;
      if (
        path.startsWith("/dashboard") ||
        path.startsWith("/exam") ||
        path.startsWith("/admin") ||
        path.startsWith("/teacher")
      ) {
        try {
          localStorage.removeItem("prismiq_user");
        } catch (e) {
          console.warn("[api] failed to clear stored user:", e?.message || e);
        }
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export function formatApiError(err) {
  const d = err?.response?.data?.detail;
  if (d == null) return err?.message || "Something went wrong.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => (e?.msg ? e.msg : JSON.stringify(e))).join(" ");
  if (typeof d === "object" && d.msg) return d.msg;
  return String(d);
}

export default client;
